"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWordsMoney = void 0;
var mround_1 = require("./mround");
var padNumber_1 = require("./padNumber");
var toWords_1 = require("./toWords");
/**
 * tekst złotych
 * @param value liczba złotych
 */
function intText(value) {
    if (value === 1) {
        return 'złoty';
    }
    var decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'złotych';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'złote';
    }
    return 'złotych';
}
/**
 * tekst groszy
 * @param value liczba groszy
 */
function fracText(value) {
    if (value === 1) {
        return 'grosz';
    }
    var decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'groszy';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'grosze';
    }
    return 'groszy';
}
/**
 * Zamiana kwoty na słownie ze słowem złoty/ch
 * @param value kwota do zamiany
 * @param currency co wstawić jako walutę, domyslnie automatycznie dopasowuje odmianę `złoty`
 * @param forceShowgr czy wymusić grosze w przypadku gdy liczba groszy jest równa 0
 */
function toWordsMoney(value, currency, forceShowgr) {
    if (currency === void 0) { currency = ''; }
    if (forceShowgr === void 0) { forceShowgr = false; }
    if (value < 0) {
        value = value * -1;
    }
    var strValue = '';
    var intValue = Math.floor(value);
    var fracValue = (0, mround_1.default)((value - intValue) * 100, 0);
    if (!currency) {
        currency = intText(intValue);
    }
    strValue = (0, toWords_1.default)(intValue) + ' ' + currency;
    if (fracValue !== 0 || forceShowgr) {
        strValue += ' ' + (0, padNumber_1.default)(fracValue, 2) + '/100';
    }
    return strValue;
}
exports.toWordsMoney = toWordsMoney;
exports.default = toWordsMoney;
//# sourceMappingURL=toWordsMoney.js.map